import { parseJSON } from './parse-json';

export const base64Decoder = <T extends object>(s: string): T => {
  const replaced = s.replace('-', '/').replace('_', '+');

  let decoded = replaced;

  try {
    decoded = atob(replaced);
  } catch (err) {
    console.error('base64Decoder ERROR', err);
    // atob payload wasn't a valid base64 string, probably it was a shared game with string params
    // such params will be parsed later, but for now we have to return valid T params
    return {} as T;
  }

  return parseJSON<T>(decoded) ?? ({} as T);
};

export const base64Encoder = (payload: any) => {
  const encoded = btoa(JSON.stringify(payload));
  const result = encoded.replace('/', '-').replace('+', '_');
  return result;
};

export const base64Utils = {
  decode: base64Decoder,
  encode: base64Encoder,
};
